import { Col as AntCol, List as AntList } from 'antd'
import styled from 'styled-components'
import TitleAnt from 'antd/lib/typography/Title'

export const Col = styled(AntCol)`
  text-align: center;
`

export const ContainerButtonAdd = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`

export const LimitContainer = styled.div`
  overflow-x: scroll;
  overflow: hidden;
  width: 100%;
`

export const List = styled(AntList)`
  min-width: 70rem;
` as React.ComponentType as new <T>() => AntList<T>

export const Title = styled(TitleAnt)`
  margin: 2rem 0;
`
